// extracted by mini-css-extract-plugin
export default {"input":"C_-z","button":"D_-z","selected":"E_-z","unavailable":"F_-z","oos":"G_-z","paperCutDisabledOverlay":"H_-z","image":"I_-z"};